import React from "react";

import { css } from "@emotion/react";
import { FooterConfiguration } from "@swo/storefront";
import { FONTS, fontSize } from "../../../styles/fonts";
import { CSS_COLORS } from "../../../styles/styles-css-variables";

export const FooterTernaryNavigation: React.FC<{ data: FooterConfiguration["externalLinks"] }> = props => {
  function renderSection(data: typeof props.data.firstSection) {
    return data.map((d, idx) => {
      return (
        <a
          target="_blank"
          rel="noopener noreferrer"
          key={JSON.stringify(d)}
          className={"text-aa"}
          css={[
            FONTS.SwarovskiFutura300,
            fontSize.x2,
            css`
              color: ${CSS_COLORS.White};
              text-decoration: none;
              margin-bottom: 15px;
            `,
          ]}
          href={d.link}
        >
          {d.label}
        </a>
      );
    });
  }

  const hrElement = (
    <hr
      css={css`
        max-width: 20px;

        margin-bottom: 20px;
        margin-left: 0;
      `}
    />
  );

  const gridStyles = css`
    display: grid;
    grid-template-columns: 1fr 1fr;
  `;

  return (
    <div>
      {hrElement}
      <div css={gridStyles}>{renderSection(props.data.firstSection)}</div>
      {hrElement}
      <div css={gridStyles}>{renderSection(props.data.secondSection)}</div>
    </div>
  );
};
